import { Button, Card, Typography, message } from "antd";
import moment from "moment";
import { useMutation, useQueryClient } from "react-query";
import { completeService } from "../../../../apis/Order";
import useReservation from "../../../../hooks/useReservation";
import { HttpError } from "../../../../network/types";
import color from "../../../../theme/color";
import { openConfirm } from "../../Confirm";
import { ColorDelivery } from "../../Icon";
import { IconForm } from "../../Icon/index.styled";
import { FlexSpace } from "../../Layout/UserInfo/index.styled";
import { ConfirmEm } from "../index.styled";

/**
 * 예약 정보 카드
 * @returns
 */
export const OrderInfoCard = () => {
  const { reservation } = useReservation();
  const queryClient = useQueryClient();

  /**
   * 작업완료 요청
   * @notice 우선 기타매장만
   */
  const { mutate } = useMutation(completeService, {
    onSuccess: () => {
      message.success("작업완료되었습니다.");
      queryClient.refetchQueries(["reservations"]);
      queryClient.refetchQueries(["OM"]);
    },
    onError: (err: HttpError) => {
      if (
        err.notTranslate ===
        "CANNOT_COMPLETED_SERVICE_UNTIL_ALL_COMPLETED_GOODS_ISSUE"
      )
        openConfirm({
          content: (
            <>
              주문상품이 모두 <ConfirmEm>&lsquo;출고완료&rsquo;</ConfirmEm>
              상태가 되어야 <ConfirmEm>&lsquo;작업 완료&lsquo;</ConfirmEm>가
              가능합니다
            </>
          ),
          title: "작업완료 불가",
          okText: "닫기",
        });
      else message.error(err.message);
    },
  });

  return (
    <Card bordered={false} bodyStyle={{ padding: "12px 16px" }}>
      <FlexSpace
        size={8}
        align="center"
        style={{ justifyContent: "space-between" }}
      >
        <FlexSpace size={2} direction="vertical">
          <FlexSpace size={2} align="center">
            <IconForm component={ColorDelivery} style={{ fontSize: 18 }} />
            <Typography.Text
              style={{
                fontSize: 13,
                fontWeight: 500,
                lineHeight: "18px",
                color: color.gray4,
              }}
            >
              주문번호
            </Typography.Text>
          </FlexSpace>
          <Typography.Text
            style={{
              fontSize: 16,
              fontWeight: 500,
              lineHeight: "24px",
              color: color.gray4,
            }}
          >
            {reservation.repairNo}
          </Typography.Text>
        </FlexSpace>
        <Button
          type="primary"
          disabled={moment().isBefore(moment(reservation.reservedAt))}
          hidden={reservation.reservedStatus !== "RESERVED"}
          onClick={() => {
            openConfirm({
              title: "작업완료",
              content: `해당 항목을 '작업완료' 하시겠습니까?`,
              okText: "작업완료",
              cancelText: "취소",
              onOk: () => {
                if (reservation.repairNo) {
                  mutate(reservation.repairNo);
                }
              },
            });
          }}
        >
          작업완료
        </Button>
      </FlexSpace>
    </Card>
  );
};
